const ACCESS_TOKEN_KEY = 'dockautomation.access_token'
const REFRESH_TOKEN_KEY = 'dockautomation.refresh_token'
const ACCESS_EXPIRES_KEY = 'dockautomation.access_expires_utc'
const REFRESH_EXPIRES_KEY = 'dockautomation.refresh_expires_utc'

function isClient(): boolean {
  return typeof window !== 'undefined'
}

export function getAccessToken(): string | null {
  if (!isClient()) return null
  const value = window.localStorage.getItem(ACCESS_TOKEN_KEY)
  return value && value.trim().length > 0 ? value : null
}

export function getRefreshToken(): string | null {
  if (!isClient()) return null
  const value = window.localStorage.getItem(REFRESH_TOKEN_KEY)
  return value && value.trim().length > 0 ? value : null
}

export function setAuthSession(params: {
  accessToken: string
  refreshToken: string
  accessTokenExpiresAtUtc?: string | null
  refreshTokenExpiresAtUtc?: string | null
}) {
  if (!isClient()) return

  window.localStorage.setItem(ACCESS_TOKEN_KEY, params.accessToken)
  window.localStorage.setItem(REFRESH_TOKEN_KEY, params.refreshToken)
  window.localStorage.setItem(ACCESS_EXPIRES_KEY, params.accessTokenExpiresAtUtc ?? '')
  window.localStorage.setItem(REFRESH_EXPIRES_KEY, params.refreshTokenExpiresAtUtc ?? '')
}

export function clearAuthSession() {
  if (!isClient()) return

  window.localStorage.removeItem(ACCESS_TOKEN_KEY)
  window.localStorage.removeItem(REFRESH_TOKEN_KEY)
  window.localStorage.removeItem(ACCESS_EXPIRES_KEY)
  window.localStorage.removeItem(REFRESH_EXPIRES_KEY)
}
